export default __webpack_public_path__ + "static/media/logo.2ac208fe.png";